import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { handleNumberChange } from '../../utils'

const NumberField = ({ value, onChange, allowDecimals, ...props }) => {
    return (
        <TextField
            {...props}
            value={value}
            onChange={(e) =>
                handleNumberChange(e.target.value, (value) => onChange(value))
            }
        />
    )
}

NumberField.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
}

export default NumberField
